<template>
  <div id="schedule-study-start-modal" data-backdrop="static" data-keyboard="false" class="modal modal-position fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content p-0">
        <div class="modal-body p-0">
          <a @click="hideModal()" class="btn-close">a</a>
          <div class="row">
            <div class="col-md-12 heading text-center">
              Select a date to start the study.
            </div>
          </div>
          <div class="form-group row date-container">
            <label for="inputStartDate" class="col-sm-3 col-form-label pr-0">Start date</label>
            <div class="col-sm-9 pl-0">
              <Datepicker
                id="inputStartDate"
                input-class="form-control"
                v-model="startDate"
                placeholder="Select"
                :highlighted="{
                  dates: [getLocalTimeOfParticipant(new Date())]
                }"
                :use-utc="true"
              ></Datepicker>
              <span class="fa fa-calendar-o"></span>
            </div>
          </div>
          <div class="row download-modal pt-30 pb-40 text-center">
            <button class="btn schedule-btn" :disabled="!startDate || apiCallInProgress" @click="scheduleStudyStart(true)">
              Schedule
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import _ from "lodash";
import * as DateTime from "../../services/date-time-functions";
export default {
  name: "schedule-study-start",
  components: {
    Datepicker
  },
  props: {
    participantId: {
      type: String,
      required: true
    },
    piId: {
      type: String,
      required: true
    },
    showModal: {
      type: Boolean,
      required: true
    },
    participantDetails: {
      type: Object,
      default: null,
      required: false
    }
  },
  data() {
    return {
      startDate: null,
      studyId: this.$route.params.studyId,
      apiCallInProgress: false,
      participantLocalDate: null
    };
  },
  mounted() {},
  watch: {
    showModal() {
      if (!this.participantId) {
        return;
      }
      if (this.showModal) {
        window.$("#schedule-study-start-modal").modal("show");
      } else {
        window.$("#schedule-study-start-modal").modal("hide");
      }
    }
  },
  methods: {
    hideModal() {
      window.$("#schedule-study-start-modal").modal("hide");
      this.$emit("toggleScheduleModal", false);
      this.startDate = null;
      this.apiCallInProgress = false;
    },
    scheduleStudyStart() {
      this.apiCallInProgress = true;
      let scheduleStartDateMoment = moment(this.startDate);
      const scheduledStartDate = scheduleStartDateMoment.format("DD MMM YYYY");
      let absScheduledStartDate = scheduleStartDateMoment.format("DD MMM YYYY");
      const scheduleStartDateUTCDate = moment.utc(scheduledStartDate, "DD MMM YYYY");

      const data = {
        participantId: this.participantId,
        studyId: this.studyId,
        triggeredBy: this.piId,
        scheduledStartDate: scheduleStartDateUTCDate.format("YYYY-MM-DD"),
        participantLocalDate: this.participantLocalDate,
        scheduledBy: this.piId
      };

      let siteMemberLocalOffset = moment().utcOffset();
      if (siteMemberLocalOffset < 0) {
        // For -ve timezones, the date offset is positive.
        siteMemberLocalOffset = -1 * siteMemberLocalOffset;
        const localDateObject = DateTime.getLocalDateTime(_.cloneDeep(this.startDate), siteMemberLocalOffset);
        data.scheduledStartDate = localDateObject.localDate;
        absScheduledStartDate = localDateObject.basicLocalDate;
        scheduleStartDateMoment = localDateObject.localDateMoment;
      }

      //TODO figure out this comparision.
      let toastMsg = "Study start will be requested as scheduled";
      if (moment(data.scheduledStartDate).isSame(this.participantLocalDate, "day")) {
        toastMsg = `Study start has been requested and is awaiting participant confirmation`;
      }

      //TODO figure out this comparision
      //if(scheduleStartDateMoment.isBefore(this.participantLocalDate, 'day')){
      if (moment(data.scheduledStartDate).isBefore(this.participantLocalDate, "day")) {
        this.$swal({
          title: "You selected a date in the past. When selecting a date in the past, the participant’s number of days in the study will be reflective of the date you have chosen in the past until today. Would you like to continue?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#4a4a4a",
          cancelButtonColor: "#1e8fe1",
          cancelButtonText: "Cancel",
          confirmButtonText: "Yes"
        }).then(({ dismiss }) => {
          if (dismiss === "cancel") {
            this.apiCallInProgress = false;
          } else {
            this.scheduleStartApiCall(data, absScheduledStartDate, scheduleStartDateMoment, toastMsg);
          }
        });
      } else {
        this.scheduleStartApiCall(data, absScheduledStartDate, scheduleStartDateMoment, toastMsg);
      }
    },
    scheduleStartApiCall(data, scheduledStartDate, scheduleStartDateMoment, toastMsg) {
      this.$api.triggerParticipantDayZero(data).then(
        () => {
          this.$emit("studyStartScheduled", `Study start is scheduled for <span class="scheduled-date">${scheduledStartDate}</span>`, scheduleStartDateMoment);
          this.$toastr.success(toastMsg);
          this.hideModal();
        },
        error => {
          this.apiCallInProgress = false;
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Something went wrong while scheduling study start for participant");
        }
      );
    },
    getLocalTimeOfParticipant(date) {
      const participantStudyStartDate = DateTime.getLocalDateTime(date, this.participantDetails.participantLocalOffset);
      this.participantLocalDate = participantStudyStartDate.localDate;
      return new Date(participantStudyStartDate.fullLocalDateTime);
    }
  }
};
</script>

<style scoped lang="scss" src="../../../public/static/fonts.scss"></style>
<style lang="scss" scoped>
#schedule-study-start-modal {
  .modal-dialog {
    width: 379px;

    .modal-body {
      .heading {
        width: 100%;
        color: #666669;
        font-size: 18px;
        font-family: Roboto-Bold;
        padding: 39px 63px 0;
      }

      .download-modal {
        width: 100%;
        display: inline-block;
      }

      .btn-close {
        position: absolute;
        right: 11px;
        top: 10px;
        width: 12px;
        height: 12px;
        cursor: pointer !important;
        color: #fff;
        z-index: 999999;
      }

      .btn-close:hover {
        opacity: 0.3;
      }

      .btn-close:before,
      .btn-close:after {
        position: absolute;
        left: 7px;
        content: " ";
        height: 11px;
        width: 2.5px;
        background-color: #666669;
      }

      .btn-close:before {
        transform: rotate(45deg);
      }

      .btn-close:after {
        transform: rotate(-45deg);
      }

      .fa-calendar-o {
        font: normal normal normal 14px/1 FontAwesome;
        position: absolute;
        z-index: 2;
        display: block;
        width: 2.375rem;
        height: 2.375rem;
        line-height: 2.375rem;
        text-align: center;
        pointer-events: none;
        color: #2291e1;
        right: 13px;
        top: -1px;
      }

      .date-container {
        padding: 27px 25px 0px 25px;
        margin-bottom: 0;

        .col-form-label {
          color: #4a4a4a;
        }
      }

      .schedule-btn {
        font-size: 14px;
        padding: 6px 29px;
        background-color: #1e8fe1 !important;
        border-color: #1e8fe1 !important;
        color: #fff;
        border-radius: 25px;

        &.cancel:hover {
          box-shadow: none;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.vdp-datepicker {
  font-family: Lato-Regular;
  font-weight: bold !important;
  font-size: 12px !important;
  color: #4a4a4a;

  .vdp-datepicker__calendar {
    .cell {
      &.day-header {
        color: #b0bac9 !important;
        font-size: 12px !important;
      }

      &.selected {
        border-radius: 2px !important;
        background-color: #1e8fe1 !important;
        color: #fff !important;
      }
    }
  }
}
</style>
